import template from './index.html'

const videoGridMockComponent = (params) => {
    return {
        players: [],
        scrollView: {
            backgroundColor: 'transparent',
            top: 0,
            height: 0,
            left: 0,
            width: 0
        },
        camGrid: {
            height: 0,
            width: 0,
            rotate: 0
        },
        async init() {
            this.$nextTick(() => {
                this.$el.innerHTML = template
            })
        },
        addPlayer(params) {
            console.log(params)
            this.players.push({
                id: params.id,
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                className: '',
                img: ''
            })
        },
        getPlayerById(id){
            for (let i = 0; i < this.players.length; i++) {
                if (this.players[i].id == id) return this.players[i]
            }
        },
        setPlayerParams(params) {
            const player = this.getPlayerById(params.id)
            if (!player) {
                console.error('Player not found ' + id)
                return
            }
            params.params.forEach(el => {
                player[el[0]] = el[1]
            })
        },
        startPlayer(params) {
            const player = this.getPlayerById(params.id)
            if (!player) {
                console.error('Player not found ' + id)
                return
            }
            const id = player.id <= 1 ? player.id : 1
            setTimeout(_ => {
                player.img = 'url(./image/videoGridMock/'+id+'.gif)'
                window._app._onNativeEvent('onPlayInfo', {id: player.id})
            }, (Math.floor(Math. random()*10) + 1)*200)
        },
        stopPlayer(params) {
            const player = this.getPlayerById(params.id)
            if (!player) {
                console.error('Player not found ' + id)
                return
            }
            setTimeout(_ => {
                player.img = ''
                window._app._onNativeEvent('onStop', {id: player.id})
            }, (Math.floor(Math. random()*10) + 1)*100)
        },
        removePlayer(params) {
            for (let i = 0; i < this.players.length; i++) {
                if (this.players[i].id == params.id) {
                    this.players.splice(i, 1)
                    break
                }
            }
        },
        setScrollParams(params) {
            params.params.forEach(el => {
                if (el[0] == 'scrollY') {
                    if (this.$refs.scrollView) this.$refs.scrollView.scrollTop = el[1]
                    return
                } else if (el[0] == 'scrollX') {
                    if (this.$refs.scrollView) this.$refs.scrollView.scrollLeft = el[1]
                    return
                }
                this.scrollView[el[0]] = el[1]
            })
        },
        setCamGridParams(params) {
            params.params.forEach(el => {
                this.camGrid[el[0]] = el[1]
            })
        }
    }
}

export { videoGridMockComponent }
